import React from 'react'
import { Tooltip } from 'antd'

export type TrafficLightStatus = 'none' | 'green' | 'orange' | 'red'

export interface TrafficLightProps {
  status: TrafficLightStatus
  tooltip?: string
  children?: React.ReactNode
}

const STATUS_COLORS: Record<TrafficLightStatus, string> = {
  none: 'transparent',
  green: '#52c41a',
  orange: '#faad14',
  red: '#ff4d4f',
}

export const TrafficLight: React.FC<TrafficLightProps> = ({
  status,
  tooltip,
  children,
}) => {
  const borderColor = STATUS_COLORS[status]

  const cellStyle: React.CSSProperties = {
    borderLeft: status !== 'none' ? `3px solid ${borderColor}` : undefined,
    paddingLeft: status !== 'none' ? '8px' : '11px', // компенсация для выравнивания
  }

  const content = (
    <div style={cellStyle}>
      {children}
    </div>
  )

  if (tooltip && status !== 'none') {
    return (
      <Tooltip title={tooltip} placement="top">
        {content}
      </Tooltip>
    )
  }

  return content
}
